import React from "react";
import ActionDeleteButton from "../UIComponent/ActionTableComponent/ActionDeleteButton";
import { formatPrice } from "../common/FormatePrice";

const ApprovalProcessTable = (props) => {
  return (
    <div>
      <div className="mb-2 overflow-x-auto">
        <table className="stretegic-member-tbl w-full mx-auto my-5 fixed_header">
          <thead>
            <tr className="text-base font-bold flex">
              <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[28%]">
                <div className="font-bold tble-th-txt text-left">Starting Amount</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[28%]">
                <div className="font-bold tble-th-txt text-left">Ending Amount</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[28%]">
                <div className="font-bold tble-th-txt text-left">Approval Email</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[16%]">
                <div className="font-bold tble-th-txt text-left">Action</div>
              </th>
            </tr>
          </thead>

          <tbody className="scrollit text-sm custom-tbody globle-setting-tbody">
            {props.creditNoteApprovalList && props.creditNoteApprovalList.length > 0 ? (
              <>
                {props.creditNoteApprovalList.map((creditNote, creditNoteIndex) => {
                  return (
                    <tr className="custom-tbl-td flex items-center" key={creditNoteIndex}>
                      <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#181818] w-[28%]">
                        {/* {creditNote.financeStartingAmount} */}
                       {formatPrice(creditNote.financeStartingAmount)}
                      </td>
                      <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#181818] w-[28%]">
                        {/* {creditNote.financeEndingAmount} */}
                        {formatPrice(creditNote.financeEndingAmount)}
                      </td>
                      <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#181818] w-[28%]">
                        {`${creditNote.financeApprovalEmail}`}
                      </td>
                      <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#181818] w-[16%] gst-edit-btn">
                        <span className="flex items-center">
                          <button
                            className="action-btn mr-4 flex items-center"
                            aria-controls="add-edit-modal"
                            onClick={() => {
                              props.getCreditNoteDataById(creditNoteIndex);
                            }}
                          >
                            <p className="ml-2 tool-tip-txt underline text-[#81a3b8]">
                              Edit
                            </p>
                          </button>
                          <ActionDeleteButton
                            onActionClick={() => props.deleteCreditNote(creditNote.financeCreditNoteApprovalId)}
                          />
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <>
                <tr className="grid justify-items-center">
                  <td className="text-lg text-[#181818]	">No Records Found</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default ApprovalProcessTable;